<div class="captcha-dialog">
  <h2 id="captcha-dialog-title" class="captcha-dialog__title">Verify you're human</h2>
  <p class="captcha-dialog__body">
    Unusual activity was detected. Please complete the verification below to continue.
  </p>
  <div #captchaContainer class="captcha-dialog__widget"></div>
  <div class="captcha-dialog__actions">
    <forge-button variant="text" (click)="cancel()">Cancel</forge-button>
  </div>
</div>
